module.exports = __webpack_public_path__ + "static/media/ic_bag_big.c0097334.svg";